import axios from "axios";
import store from "./store";
import router from "./router"; // Assuming you are using Vue Router or similar

const instance = axios.create({
  baseURL: "https://odeurs.enercycle.ca:3000",
});

instance.interceptors.request.use((config) => {
  if(config.url !== '/v1/testconnection'){
    store.commit("isLoading");
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    store.commit("isNotLoading");
    return response;
  },
  (error) => {
    store.commit("isNotLoading");

    if (axios.isAxiosError(error)) {
      if (error.response) {
        // Handle known error responses
        const status = error.response.status;

        if (status === 401) {
          // Redirect to login if unauthorized
          router.push({ name: 'Home' });
          localStorage.clear("jwtToken")
        } else if (status === 403) {
          store.commit("thereIsErrorConnecting", 'Accès refusé');
        } else if (status >= 500) {
          store.commit("thereIsErrorConnecting", 'Erreur serveur');
        }
      }

      // Handle network or connection issues
      if (error.code === 'ERR_NETWORK') {
        store.commit("internetConnection", false);
        store.commit("thereIsErrorConnecting", 'Problème de connexion réseau');
      } else {
        store.commit("internetConnection", true);
      }
    } else {
      // Non-Axios error or other unhandled error cases
      console.error("Unhandled error:", error);
    }

    return Promise.reject(error);
  }
);

export default instance;
